export class AustralianAddress {

  private _unitNo: string;
  private _buildingNo: string;
  private _streetName: string;
  private _floorNo: string;
  private _city: string;
  private _state: string;
  private _postcode: number;
  private _countrycode: string;
  private _timezone: string;
  private _createdAt: Date;
  private _updatedAt: Date;
  private _createdLocation: string;
  private _updatedLocation: string;
  private _enabled: boolean;

  public getUnitNo(): string {
    return this._unitNo;
  }

  public setUnitNo(value: string) {
    this._unitNo = value;
  }

  public getBuildingNo(): string {
    return this._buildingNo;
  }

  public setBuildingNo(value: string) {
    this._buildingNo = value;
  }

  public getStreetName(): string {
    return this._streetName;
  }

  public setStreetName(value: string) {
    this._streetName = value;
  }

  public getCity(): string {
    return this._city;
  }

  public setCity(value: string) {
    this._city = value;
  }

  public getState(): string {
    return this._state;
  }

  public setState(value: string) {
    // TODO: use state values rather than free text
    this._state = value;
  }

  public getPostcode(): number {
    return this._postcode;
  }

  public setPostcode(value: number) {
    this._postcode = value;
  }

  public getCountrycode(): string {
    return this._countrycode;
  }

  public getCreatedAt(): Date {
    return this._createdAt;
  }

  public getUpdatedAt(): Date {
    return this._updatedAt;
  }

  public setUpdatedAt(value: Date) {
    this._updatedAt = value;
  }

  public getCreatedLocation(): string {
    return this._createdLocation;
  }


  public getUpdatedLocation(): string {
    return this._updatedLocation;
  }

  public setUpdatedLocation(value: string) {
    this._updatedLocation = value;
  }

  public getEnabledStatus(): boolean {
    return this._enabled;
  }
  public getTZ(): string {
    return this._timezone;
  }

  public getFloorNo(): string {
    return this._floorNo;
  }

  public setFloorNo(value: string) {
    this._floorNo = value;
  }


  // public setTZ(): void {
  //   // TODO: set tz in relation to the address/state
  //
  // }

  constructor(city: string, state: string, postcode: number, street?: string, buildno?: string, unitno?: string, floor?: string) {

    if ( street != null ) {
      this._streetName = street;
    }

    if ( buildno != null ) {
      this._buildingNo = buildno;
    }

    if ( unitno != null ) {
      this._unitNo = unitno;
    }

    if ( floor != null ) {
      this._floorNo = floor;
    }

    this._city = city;
    this._state = state;
    this._postcode = postcode;
    this._countrycode = 'AU';
    this._enabled = true;
    this._createdAt = new Date();
    this._createdLocation = 'TODO';
  }

  public toString(): string {

    return 'City: ' + this._city
      + ' State: ' + this._state
      + ' Postcode: ' + this._postcode
      + ' CountryCode: ' + this._countrycode
      + ' Enabled?: ' + this._enabled
      + ' Created location: ' + this._createdLocation;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/australianAddress.ts